import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import * as echarts from 'echarts';
import { JgOption, JgLineData } from './declare';
import { exportOption } from './option';
import { EChartsOption } from 'echarts';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: { default: [] },
    width: { default: '650px' },
    height: { default: '450px' },
    option: { default: {} },
    area: {},
    dotted: {},
    dot: {},
    pointer: { default: null },
    hideLegend: { type: Boolean, default: false },
    toolTitle: { default: '' },
    yPosition: { default: [] },
    legendSelected: {},
    onLineClick: {},
    onLineMouseover: {},
    optionsInit: {}
  },
  emits: ["LineClick", "LineMouseover", "optionsInit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const JgLineStyle = ref<string>('');
const JgLineDom = ref<HTMLElement>();
const JgInstance = ref();
function Render(data: any) {
  let chartDom = JgLineDom.value;
  var myChart = echarts.init(chartDom!);
  let option: JgOption;
  option = exportOption(props, data);
  emit('optionsInit', option);
  props.optionsInit && props.optionsInit(option);
  myChart.clear();
  option && myChart.setOption(option);
  // 注册事件
  myChart.on('click', 'series', function (params: any) {
    // 限制点击事件触发区域
    props.onLineClick && props.onLineClick(params);
    emit('LineClick', params);
  });

  myChart.on('mouseover', 'series', function (params: any) {
    props.onLineMouseover && props.onLineMouseover(params);
    emit('LineMouseover', params);
  });

  JgInstance.value = myChart;
}

onMounted(() => {
  watch(
    () => props.data,
    value => {
      let Renderdata = [] as any;
      if (typeof value[0] === 'string') {
        Renderdata = eval('(' + value[0] + ')');
      } else if (Array.isArray(value)) {
        Renderdata = value;
      }
      Renderdata.length > 0 && Render(Renderdata);
    },
    { immediate: true, deep: true },
  );
});

// 对外暴露方法，抛出echarts渲染实例
function getInstance() {
  return JgInstance.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "jg-echars-line",
    ref_key: "JgLineDom",
    ref: JgLineDom,
    class: "jg-echars-line",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, null, 4))
}
}

})